/**
 * The widget's event hook. `track(name, params)` is the one call every feature already makes; since 2026-10-29 it feeds
 * Gyro's own usage record (usage/featureEvents.ts: screens, actions, engagement, batched to `POST /v1/usage/events`
 * under the signed-in caller) and nothing else. The Aptabase client that used to live here is gone: no third-party
 * vendor, no app key, no outside host. `initTelemetry` stays as a no-op so hosts that call it keep building.
 *
 * Params: only the contract's eight keys travel (`app`, `tool`, `model`, `skill`, `tab`, `kind`, `result`, `count`),
 * scalar values, strings of 40 characters or fewer; anything else a call site passes is dropped here, never sent.
 */
import { usageCapture } from './usage/featureEvents.js';
/** Kept for hosts: it switches nothing on or off (the usage record has no app key and no opt-in). */
export function initTelemetry(_option) {
    /* no-op since the first-party usage record (2026-10-29) */
}
/** Record an action. Fire-and-forget; never throws. */
export function track(eventName, props) {
    usageCapture().feature(eventName, props);
}
/** True once a page has somewhere to send the usage record (the widget or the console installed its sink). */
export function telemetryEnabled() {
    return usageCapture().snapshot().hasSink;
}
//# sourceMappingURL=telemetry.js.map